import React from 'react'
import { createRoot } from 'react-dom/client'

function MenuItems({ items, main = true }) {
  return (
    <ul className={main ? 'navbar-nav' : 'nav nav-sm flex-column'}>
      {items.map((item) => (
        <li className="nav-item" key={item.id || item.url || item.name}>
          {item.items ? (
            <>
              <a
                className={`nav-link${item.active ? ' active' : ''}`}
                href={`#${item.id}`}
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls={item.id}
              >
                {item.icon ? <i className={`fe fe-${item.icon}`}></i> : null}
                {item.name}
                {item.badge ? <span className="badge bg-primary ms-auto">{item.badge}</span> : null}
              </a>
              <div className="collapse" id={item.id}>
                <MenuItems items={item.items} main={false} />
              </div>
            </>
          ) : (
            <a className={`nav-link${item.active ? ' active' : ''}`} href={item.url}>
              {item.icon ? <i className={`fe fe-${item.icon}`}></i> : null}
              {item.name}
              {item.badge ? <span className="badge bg-primary ms-auto">{item.badge}</span> : null}
            </a>
          )}
        </li>
      ))}
    </ul>
  )
}

function SidebarMenu({ sections }) {
  return (
    <>
      {sections.map((section, index) => (
        <React.Fragment key={section.heading || 'main'}>
          {section.heading ? (
            <>
              <hr className="navbar-divider my-3" />
              <h6 className="navbar-heading">
                {section.icon ? <i className={`fe fe-${section.icon}`}></i> : null} {section.heading}
              </h6>
            </>
          ) : null}
          <MenuItems items={section.items || []} />
        </React.Fragment>
      ))}
    </>
  )
}

export function mountSidebarMenu(el) {
  let sections = []
  try {
    sections = JSON.parse(el?.dataset?.sections || '[]')
  } catch (e) {
    sections = []
  }
  const root = createRoot(el)
  root.render(<SidebarMenu sections={sections} />)
}
